import DataProvider from 'apiclient';
import AuthProvider from 'auth/AuthProvider';
import ThemeConfig  from 'style';
import Routes       from 'Routes';


export default function App() {
    return (
        <DataProvider>
            <ThemeConfig>
                <AuthProvider>
                    <Routes />
                </AuthProvider>
            </ThemeConfig>
        </DataProvider> 
    );
}